import { useState } from 'react';
import { useStore, useSelector } from 'react-redux';

// reducers
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

import { error as toastError } from 'hyc-store/reducers/toast';

// helpers
import * as helper from './helper';

// components
import { Button } from 'shared/components/bulma/button';
import { ModalNoGos } from './modal-no-gos';


const ProductScan = ({ customer }) => {

    const store = useStore();
    const country = useSelector(selectCountry);

    const [barcode, setBarcode] = useState('');
    const [product, setProduct] = useState('');
    const [modal, setModal] = useState(false);

    const handleChange = (event) => {
        setBarcode(event.target.value);
    }

    const handleKeyPress = async (event) => {
        if (event.charCode !== 13) {
            return;
        };

        const product = await helper.getProduct(barcode, country);

        if (product && product.barcode) {
            setModal(true);
            setProduct(product);
        } else {
            store.dispatch(toastError("Barcode invalid, please try again."));
        };
    }

    return (
        <>
            <Button className="is-info is-afloat-top-right">
                <input className="input" type="text"
                    onChange={handleChange} placeholder="Scan a barcode"
                    onKeyPress={handleKeyPress} />
            </Button>
            <ModalNoGos modal={modal} handleModal={setModal} product={product} customer={customer} />
        </>
    );
}


export { ProductScan };
